import React, { useState, Fragment } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { Formik, Form } from 'formik'
import moment from 'moment'
import decode from 'jwt-decode'
import { pick, pickBy, isNull } from 'lodash'

import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'

import useFirebase from '../../useFirebase'
import {
  TextField,
  NumberField,
  DateField,
  RadioGroupField,
  CustomerSelectField,
  InsurerSelectField
} from '../../form'
import success from '../../components/Snackbar/Success'
import withLoading from '../../components/withLoading'
import CustomerForm from './CustomerForm'
import ProposalSelector from './ProposalSelector'
import PolicySelector from './PolicySelector'

function FormView({ classes, id, data, onSubmit, onCreateCustomer }) {
  const firebase = useFirebase()
  const storage = firebase.storage()
  const [url, setUrl] = useState(null)
  const [anchorEl, setAnchorEl] = useState(null)
  console.log(data)
  const init = pick(data.document, [
    'cod',
    'type',
    'due_date',
    'description',
    'net_value',
    'fee',
    'term'
  ])
  const initialValues = pickBy(init, value => !isNull(value))
  console.log(init, initialValues)
  return (
    <div className={classes.wrapper}>
      <div className={classNames([classes.column, classes.form])}>
        <Formik
          initialValues={{
            ...initialValues,
            issue_date:
              (data.document && data.document.issue_date) ||
              (data.document &&
                data.document.due_date &&
                moment(data.document.due_date)
                  .add(-1, 'y')
                  .format('YYYY-MM-DD')),
            customer_id:
              data.document &&
              data.document.customer &&
              data.document.customer.id,
            insurer_id:
              data.document &&
              data.document.insurer &&
              data.document.insurer.id,
            parent_id:
              data.document && data.document.parent && data.document.parent.id
          }}
          onSubmit={onSubmit}>
          {({ values, errors, setFieldValue }) => (
            <Form>
              <Card>
                <CardContent>
                  <Grid
                    container
                    spacing={16}
                    direction="row"
                    justify="inherit"
                    alignItems="flex-start">
                    <Grid item sm>
                      <RadioGroupField name="type" options={options} />
                    </Grid>
                    <Grid item sm={4}>
                      <TextField
                        required
                        fullWidth
                        name="cod"
                        label="Número do documento"
                      />
                    </Grid>
                    <Grid item sm={3}>
                      <DateField
                        required
                        fullWidth
                        name="due_date"
                        label="Vencimento"
                      />
                    </Grid>
                    <Grid
                      item
                      sm={6}
                      onClick={event => setAnchorEl(event.currentTarget)}>
                      <CustomerSelectField
                        isClearable
                        name="customer_id"
                        onCreateOption={name => {
                          const [cod] = data.document.metadata.cpfs
                          return CustomerForm({ name, cod, anchorEl }).then(
                            values => {
                              return onCreateCustomer(values).then(customer => {
                                setFieldValue('customer_id', customer.id)
                              })
                            }
                          )
                        }}
                      />
                    </Grid>
                    <Grid item sm={6}>
                      <InsurerSelectField name="insurer_id" />
                    </Grid>
                    {values.type === 'PROPOSAL' && (
                      <Fragment>
                        <Grid item sm>
                          <TextField
                            required
                            fullWidth
                            name="description"
                            label="Descrição"
                          />
                        </Grid>

                        <Grid item sm={2}>
                          <NumberField
                            required
                            fullWidth
                            name={`net_value`}
                            prefix="R$"
                            label="Prêmio"
                            helperText="Prêmio Líquido"
                          />
                        </Grid>
                        <Grid item sm={2}>
                          <NumberField
                            required
                            fullWidth
                            name={`fee`}
                            suffix="%"
                            label="Comissão"
                          />
                        </Grid>
                        <Grid item sm={2}>
                          <NumberField
                            required
                            fullWidth
                            name={`term`}
                            suffix="x"
                            label="Parcelas"
                            helperText="Qnt de Parcelas"
                          />
                        </Grid>
                        <PolicySelector
                          setUrl={setUrl}
                          customer_id={values.customer_id}
                          due_date={values.due_date}
                        />
                      </Fragment>
                    )}
                    {values.type === 'POLICY' && (
                      <Grid item sm={3}>
                        <DateField
                          required
                          fullWidth
                          name={`issue_date`}
                          label="Dt Emissão"
                        />
                      </Grid>
                    )}
                    {values.type === 'POLICY' &&
                      values.customer_id &&
                      values.insurer_id && (
                        <ProposalSelector
                          setUrl={setUrl}
                          customer_id={values.customer_id}
                          insurer_id={values.insurer_id}
                          due_date={values.due_date}
                        />
                      )}
                  </Grid>
                </CardContent>
                <CardActions className={classes.action}>
                  <IconButton
                    aria-label="visualizar"
                    onClick={() => {
                      const user = decode(window.token)

                      const pathReference = storage.ref(
                        `orgs/${user.org}/docs/${id}.pdf`
                      )
                      pathReference.getDownloadURL().then(url => setUrl(url))
                    }}>
                    <Icon color="secondary">picture_as_pdf</Icon>
                  </IconButton>
                  <Button
                    type="reset"
                    size="small"
                    onClick={() => setUrl(null)}>
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    size="small"
                    variant="contained"
                    color="secondary">
                    Salvar
                  </Button>
                </CardActions>
              </Card>
            </Form>
          )}
        </Formik>
      </div>
      {url && (
        <div className={classes.column}>
          <iframe
            title="Documento"
            width="100%"
            height="100%"
            frameBorder="0"
            src={url}
          />
        </div>
      )}
    </div>
  )
}

FormView.propTypes = {
  id: PropTypes.string.isRequired
}

const options = [
  { value: 'PROPOSAL', label: 'PROPOSTA' },
  { value: 'POLICY', label: 'APÓLICE' }
]

const documentFields = gql`
  fragment documentFields on Document {
    id
    cod
    type
    due_date

    metadata

    customer {
      id
      cod
      name
    }
    insurer {
      id
      cod
      name
    }
    parent {
      id
      cod
    }

    ... on Proposal {
      description
      net_value
      fee
      term
    }
  }
`

const query = gql`
  query document($id: ID!) {
    document(id: $id) {
      ...documentFields
    }
  }
  ${documentFields}
`
const withQuery = graphql(query, {
  options: ({ id }) => ({
    variables: { id }
  })
})

const withSave = graphql(
  gql`
    mutation updateDocument($id: ID!, $data: DocumentInput!) {
      updateDocument(id: $id, data: $data) {
        ...documentFields
      }
    }
    ${documentFields}
  `,
  {
    props: ({ mutate, ownProps }) => ({
      onSubmit: data => {
        console.log(ownProps, data)
        return mutate({ variables: { id: ownProps.id, data } }).then(() =>
          success({ message: 'Atualizado!' })
        )
      }
    })
  }
)

const withCreateCustomer = graphql(
  gql`
    mutation createCustomer($data: CustomerInput!) {
      createCustomer(data: $data) {
        id
        cod
        name
      }
    }
  `,
  {
    props: ({ mutate, ownProps }) => ({
      onCreateCustomer: data => {
        // console.log(mutate, ownProps, values)
        return mutate({ variables: { data } }).then(({ data }) => {
          console.log(data)

          const { createCustomer: customer } = data
          success({ message: `Cliente: "${customer.name}" criado!` })
          return customer
        })
      }
    }),
    options: {
      update: (proxy, { data: { createCustomer } }) => {
        const query = gql`
          query {
            customers {
              id
              cod
              name
            }
          }
        `
        const data = proxy.readQuery({ query })
        data.customers.push(createCustomer)
        proxy.writeQuery({ query, data })
      }
    }
  }
)

const styles = theme => ({
  wrapper: {
    display: 'flex',
    flex: 1,
    flexFlow: 'row',
    alignContent: 'stretch'
  },
  column: {
    flex: '1'
  },
  form: {
    maxWidth: (1024 / 3) * 2
  },
  action: {
    justifyContent: 'flex-end'
  }
})

export default compose(
  withStyles(styles),
  withQuery,
  withLoading,
  withSave,
  withCreateCustomer
)(FormView)
